

export class Appendix {
    Id: number;
    StudyId: number;
    Name: string;

    constructor(id: number, studyId: number, name: string) { this.Id = id; this.StudyId = studyId; this.Name = name; }

    static GetAppendixName(id: number): string {
        switch (id) {
            case (0): return "VITAL (Overall)";
            case (1): return "VITAL-1 (Paxlovid)";
            case (2): return "NEURO (Overall)";
            case (3): return "NEURO-1 (tDCS & BrainHQ)";
            case (4): return "SLEEP (Overall)";
            case (5): return "SLEEP-1 (Modafinil/Solriamfetol)";
            case (6): return "SLEEP-2 (Melatonin/Light)";
            case (7): return "AUTONOMIC (Overall)";
            case (8): return "AUTONOMIC-1 (IVIG)";
            case (9): return "AUTONOMIC-2 (Ivabradine)";
            case (10): return "ENERGIZE (Overall)";
            case (11): return "ENERGIZE-1 (Cardiopulmonary Rehab)";
            case (12): return "ENERGIZE-2 (Structured Pacing)";
            case (90): return "VITAL (Unassigned)";
            case (91): return "NEURO (Unassigned)";
            case (92): return "AUTONOMIC (Unassigned)";
            case (93): return "SLEEP (Unassigned)";
            case (94): return "ENERGIZE (Unassigned)";
            default: return "Unknown";
        }
    }

    static GetOutcomeCount(appendixId: number): number {
        switch (appendixId) {
            case (1): return 3;
            case (3): return 1;
            default: return 0;
        }
    }

    //sorts in-place, with Unassigned at end of list
    static SortByName(list: Appendix[]): void {
        list.sort((a: Appendix, b: Appendix) => {
            if ((a.Id >= 90 && b.Id >= 90) || (a.Id < 90 && b.Id < 90)) { return a.Name.localeCompare(b.Name); }
            else if (a.Id >= 90 && b.Id < 90) { return 1; }
            else if (a.Id < 90 && b.Id >= 90) { return -1; }
            else return 0;
        });
    }

    static GetAppendicesToShow(appendixIds: number[]): number[] {
        let appendicesToShow: number[] = [];

        if (appendixIds.includes(1)) { appendicesToShow.push(1); } //VITAL-1
        if (appendixIds.includes(3)) { appendicesToShow.push(3); } //NEURO-1

        //SLEEP
        if (appendixIds.includes(5) && appendixIds.includes(6)) { appendicesToShow.push(4); }
        else if (appendixIds.includes(5)) { appendicesToShow.push(5); }
        else if (appendixIds.includes(6)) { appendicesToShow.push(6); }

        //AUTO
        if (appendixIds.includes(8) && appendixIds.includes(9)) { appendicesToShow.push(7); }
        else if (appendixIds.includes(8)) { appendicesToShow.push(8); }
        else if (appendixIds.includes(9)) { appendicesToShow.push(9); }

        //ENERGIZE
        if (appendixIds.includes(11) && appendixIds.includes(12)) { appendicesToShow.push(10); }
        else if (appendixIds.includes(11)) { appendicesToShow.push(11); }
        else if (appendixIds.includes(12)) { appendicesToShow.push(12); }

        return appendicesToShow;
    }

}
